/**
 * English display names for the enum raw values. One source for the web
 * dictionary (`apps/web/src/i18n/en.ts` spreads these) and for server-side
 * text the API writes itself (payment titles, CSV exports), so the words in a
 * download match the words on screen.
 */
export const ENUM_LABELS_EN = {
  rsvp: { pending: "Pending", accepted: "Going", declined: "Not going", maybe: "Maybe" },
  side: { partnerOne: "Partner 1", partnerTwo: "Partner 2", both: "Both" },
  guestCategory: { family: "Family", friend: "Friends", work: "Work", plusOne: "Plus Ones", child: "Children", vendor: "Vendors", other: "Other" },
  budgetCategory: {
    venue: "Venue", catering: "Catering", attire: "Attire", photography: "Photo & Video", music: "Music & Entertainment",
    flowers: "Flowers", decor: "Decor", stationery: "Stationery", rings: "Rings", transport: "Transport",
    beauty: "Hair & Beauty", gifts: "Gifts & Favors", honeymoon: "Honeymoon", other: "Other",
  },
  timeframe: {
    twelvePlus: "12+ Months Before", nineToTwelve: "9–12 Months Before", sixToNine: "6–9 Months Before",
    threeToSix: "3–6 Months Before", oneToThree: "1–3 Months Before", oneMonth: "1 Month Before",
    weekOf: "Week Of", dayOf: "Day Of", after: "After Wedding", custom: "Custom",
  },
  shoppingCategory: { attire: "Attire", decor: "Decor", favors: "Favors", beauty: "Beauty", stationery: "Stationery", accessories: "Accessories", other: "Other" },
  inspirationCategory: { dress: "Dress", decor: "Decor", flowers: "Flowers", cake: "Cake", venue: "Venue", hair: "Hair", makeup: "Makeup", rings: "Rings", suit: "Suit", shoes: "Shoes", other: "Other" },
  vendorType: {
    venue: "Venue", caterer: "Caterer", photographer: "Photographer", videographer: "Videographer", florist: "Florist",
    dj: "DJ", band: "Band", plannerCoord: "Planner", baker: "Baker", dressShop: "Dress Shop", suitShop: "Suit Shop",
    makeup: "Makeup Artist", hair: "Hair Stylist", transport: "Transport", officiant: "Officiant", stationery: "Stationery",
    rentals: "Rentals", other: "Other",
  },
  vendorStatus: { researching: "Researching", contacted: "Contacted", quoted: "Quoted", booked: "Booked", paid: "Paid", completed: "Completed" },
  tableShape: { round: "Round", rectangle: "Rectangle" },
} as const;

/** Raw value → English label, falling back to the raw value (unknown values from a newer client). */
export function enumLabelEn(group: keyof typeof ENUM_LABELS_EN, value: string): string {
  return (ENUM_LABELS_EN[group] as Record<string, string>)[value] ?? value;
}
